import styled from 'styled-components';

export const Container = styled.div`

    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f0f0f0;
    align-items: center;
    // -webkit-touch-callout: none;
    // -webkit-user-select: none;
    // -khtml-user-select: none; 
    // -moz-user-select: none;
    // -ms-user-select: none;
    // user-select: none;
    -webkit-tap-highlight-color: transparent;

    .div-pai {
        margin: 32px;
        background-color: #fff;
        max-width: 1096px;
        min-width: 300px;
        width: 88%;
        border-radius: 8px;
        padding-bottom: 40px;

        @media (max-width: 1330px) {
            margin-bottom: 80px;
        }

        @media (max-width: 690px) {
            margin-top: 161px;
        }

        @media(max-width: 691px) {
            margin: 24px;
            margin-top: 153px;
            margin-bottom: 80px;
        }
    }

        .div-rota {
            margin-right: 16px;
            margin-top: 40px;
            margin-left: 32px;
            width: 90%;
            overflow: hidden;
            white-space:nowrap;
            text-overflow: ellipsis;

            @media(max-width: 691px) {
                margin-left: 16px
            }
        }
            
            span {
                font-family: Montserrat;
                font-size: 14px;
                color: #2a0709;
                font-weight: 500;

                @media(max-width: 691px) {
                    font-size: 12px;
                }
            }

            .rotas {
                font-family: Montserrat;
                font-size: 14px;
                color: #a49b9b;
                font-weight: normal;

                @media(max-width: 691px) {
                    font-size: 12px;
                }
            }
        }

        .emoji {
            width: 32px;
            height: 32px;
            margin-top: 40px;
            margin-bottom: 24px;
            object-fit: contain;

            @media(max-width: 691px) {
                    margin-top: 32px
                }
        }

        h1 {
            font-family: Montserrat;
            font-size: 32px;
            margin-top: 0;
            margin-bottom: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 691px) {
                font-size: 24px;
            }
        }

        h5 {
            padding-right: 42px;
            margin-bottom: 56px;           
            font-family: Montserrat;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 691px) {
                margin-bottom: 2rem;
                padding: 0   
            }
        }

        .titulo {
            padding: 0 2rem;
    
            @media(max-width: 691px) {
                padding: 0 1rem;
            }
        }

        .linha {
            border-left: none;
            border-top: 1px solid #f3f3f3;
            margin: 54px 32px;

            :last-child {
                border-top: 0px solid #fff;
                margin: 64px,
            }

            @media(max-width: 691px) {
                margin: 56px 0px;
            }
        }
        
        h3 {
            margin-top: 64px;
            margin-bottom: 40px;
            margin-left: 32px;
            font-family: Montserrat;
            font-size: 20px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 690px) {
                margin-left: 16px;
                margin-top: 20px; 
            }
        }
        
        .calendario {
            padding: 0 2rem;
            width: 20px;
            height: 20px;
            margin-top: 40px;
            margin-bottom: 5px;
            object-fit: contain;

            @media(max-width: 690px) {
                margin-top: 32px;
                padding: 0px; 
                margin-left: 16px;
            
            }
        }
    
        .subs {
            margin-left: 32px;
            padding-bottom: 10px;
            font-family: Montserrat;
            font-size: 14px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 690px) {
                margin-left: 16px;
                margin-top: 10px;
            }
        }

        .botao {
            display: flex;
            width: 100%;
            margin-bottom: 72px;
    
            @media(max-width: 690px) {
                margin-bottom: 26px;

            }
                
        .salvar {
            cursor: pointer;
            height: 40px;
            width: 160px;
            margin-top: 70px;
            margin-left: 24px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;
            text-decoration: none;
    
        :hover {
            background-color: #9c1a1f
        }
    
        :active {
            background-color: #d7232c
        }
    
        @media(max-width: 690px) {
            margin-top: 32px;
            margin-left: 16px;
            }
    }

        .salvar1 {
            outline: none;
            border: none;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            text-decoration: none;
            transition: 0.2s;

        :hover {
            background-color: #9c1a1f;
        }

        :active {
            background-color: #d7232c
        }

        @media(max-width: 360px) {
            width: 100%;
            }
        }
    }

        .info {
            margin-top: 64px;
            margin-bottom: 40px;
            padding-left: 32px;
            padding-right: 16px;
            padding-bottom: 30px;
            font-family: Montserrat;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: center;
            color: #a49b9b;

            @media(max-width: 690px) {
                padding-left: 16px;
                margin-top: 68px;
                margin-bottom: 36px;
            }
        }

        .informacao {
            margin-bottom: 10px;
            margin-left: 32px;
            margin-right: 32px;
            font-family: Montserrat;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 690px) {
                margin-left: 16px;
            }
        }

        .dados {
            margin-left: 0px;
            margin-right: 0px;
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 50px;
            padding-bottom: 50px;
            font-family: Montserrat;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: center;
            color: #2a0709;


            @media(max-width: 690px) {
                width: 100%;
                }
            }
            
            .last-row td {
                border-bottom: none;
              }

        .situacao {
            margin-bottom: 10px;
            margin-left: 32px;
            margin-right: 45px;
            font-family: Montserrat;
            font-size: 30px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 690px) {
                margin-left: 16px;
                margin-bottom: 10px;
            }
        }

        .dadosFatura {
            margin-right: 35px;
            margin-left: 32px;
            font-family: Montserrat;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #2a0709;

            @media(max-width: 690px) {
                margin-left: 16px;
                margin-bottom: 10px;
                margin-right: 0px;
                font-weight:bold
            }
    }
    
     
        #meulink {
            color: #2a0709;
        }

        .margens{
            margin-bottom: 50px;
        }

        .coluna {
            display: flex;
            flex-direction: column;
        }

        .coluna-mobile {
            display: none;

            @media(max-width: 690px){
            display: flex;
            flex-direction: column;
            }
        }

        .row {
            display: flex;
        
            @media(max-width: 690px) {
                display: none;
            }
        }

        .row-mobile {
            display: none;

            @media(max-width: 690px) {
                display: flex;
                
            }
        }

        .row-fatura {
            display: flex;
        
            @media(max-width: 690px) {
                display: flex;
                flex-direction: column;
            }
        }


        td {
            border: none;
            border-bottom: 2px solid #f3f3f3;
            padding: 2rem 2rem;

            @media(max-width: 360px) {
                width: 100%;
                }
        }

        tr:hover {
            background-color: #FAF8F9;
        }


        table {
            border-spacing:0;
            width: 100%;

            @media(max-width: 690px) {
                display: none;
            }
        }

        .chevron {
            @media(max-width: 690px) {
            padding-right: 32px;
            transition: 0.3s transform;
            -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
            transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
        }
    }

    .div__mobile__over {

        hr {
            margin: 0 ;
            padding: 0;
            border: 0px solid #f3f3f3;

            @media (max-width: 690px) {
                // margin: 0 -16px;
                padding: 0;
                border: 1.5px solid #f3f3f3;
            }
        }

        .div__mobile {
            display: none;
            
            @media (max-width: 690px){

            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding-top: 32px;
            padding-bottom: 0;
            // margin-left: -32px;
            padding-left: 32px;
            // margin-right: -32px;
            padding-right: 32px;

            @media (max-width: 360px) {
                margin-left: -16px;
                padding-left: 16px;
                margin-right: -16px;
                padding-right: 16px;
            }
        }
            :hover {
                background-color: #faf8f9;
            }

            .head {
                margin-left: 16px;
                font-family: Montserrat;
                font-size: 16px;
                color: #a49b9b;
                font-weight: normal;
            }

            .body-div {
                margin-top: 16px;
                margin-bottom: 32px;
            }

            .body {
                font-family: Montserrat;
                font-size: 16px;
                margin-left: 16px;
                color: #2a0709;
                font-weight: normal;
            }

        }
    }

    .collapsed-div {
        gap: 2rem;
    }

    .textosemfatura {
        padding-right: 42px;           
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 400;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #a49b9b;
        line-height: 1;

        @media(max-width: 690px) {
            margin-bottom: 2rem;
            line-height: 2;
        }
    }

    .linha_null{
        border-left: none;
        border-top: 1px solid #f3f3f3;
        margin: 54px 32px;

        :last-child {
            border-top: 0px solid #fff;
            margin: 64px,
        }

        @media(max-width: 691px) {
            margin: 56px 0px;
        }
    }

    .fundo{
        padding-bottom: 100px;
        padding-left: 16px;
    }

    .texto_null{
        margin-top: 44px;
        margin-bottom: 30px;
        font-family: Montserrat;
        font-size: 20px;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        display: flex;

        @media(max-width: 690px) {
            margin-left: 0px;
        }    
    }

    .info_null{
        margin-top: 64px;
        margin-bottom: 40px;
        padding-left: 32px;
        padding-right: 16px;
        padding-bottom: 30px;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: center;
        color: #a49b9b;

        @media(max-width: 690px) {
            padding-left: 16px;
            margin-top: 68px;
            margin-bottom: 36px;
            line-height: 2;
            font-size: 16px;
        }
    }

    `
    